'use client';

import React, { createContext, useContext } from 'react';

interface BasePathContextValue {
  basePath: string;
  buildPath: (path: string) => string;
}

const BasePathContext = createContext<BasePathContextValue | undefined>(undefined);

export function BasePathProvider({ basePath = '', children }: { basePath?: string; children: React.ReactNode }) {
  const normalized = basePath ? (basePath.startsWith('/') ? basePath : `/${basePath}`) : '';

  const buildPath = (path: string) => {
    if (!normalized) return path;
    if (!path) return normalized;
    if (path.startsWith(normalized + '/')) return path; // already prefixed
    if (path.startsWith('/')) return `${normalized}${path}`;
    return `${normalized}/${path}`;
  };

  return (
    <BasePathContext.Provider value={{ basePath: normalized, buildPath }}>
      {children}
    </BasePathContext.Provider>
  );
}

export function useBasePath(): BasePathContextValue {
  const ctx = useContext(BasePathContext);
  if (!ctx) throw new Error('useBasePath must be used within BasePathProvider');
  return ctx;
}


